import type { CryptoCurrency, FiatCurrency } from '@0xtorch/core'
import type { createGetAsset } from '../utils/createGetAsset'

type Asset = CryptoCurrency | FiatCurrency

/**
 * Sodex のコイン名から Asset を解決する（vUSDC 等の v 接頭辞にも対応）
 * @param params.coin Sodex 上のコイン名
 * @param params.getAsset シンボルマップ付きアセット解決関数
 * @returns 解決できた Asset、未解決の場合は undefined
 */
export const resolveCoinAsset = (params: {
  coin: string
  getAsset: ReturnType<typeof createGetAsset>
}): Asset | undefined => {
  const { coin, getAsset } = params
  const candidates = [coin]
  if (coin.startsWith('v') && coin.length > 1) {
    candidates.push(coin.slice(1))
  }
  for (const candidate of candidates) {
    const asset = getAsset(candidate)
    if (asset) {
      return asset
    }
  }
  return undefined
}
